import type { TwinAgreement } from '@hofsync/design-system';

export const MOCK_CONTRACTS: TwinAgreement[] = [
  {
    agreement_id: 'c-001',
    agreement_number: 'K-2024-001',
    agreement_type: 'purchase_agreement',
    direction: 'purchase',
    status: 'fulfilled',
    supplier: { party_id: 'org-raiffeisen', name: 'Raiffeisen Waren-Zentrale Rhein-Main eG', short_name: 'RWZ Rhein-Main' },
    buyer: { party_id: 'org-gut-sonnenberg', name: 'Betrieb Müller', short_name: 'Betrieb Müller' },
    product: { product_id: 'p-1', name: 'Kalkammonsalpeter 27% N', category: 'inputs.fertilizer' },
    contracted_quantity: 200,
    quantity_unit: 'dt',
    unit_price: 32.50,
    currency: 'EUR',
    total_value: 6500.0,
    valid_from: '2024-02-01',
    valid_to: '2024-04-30',
    commission_pct: null,
    datasheet_required: true,
    datasheet_present: true,
    fulfillment_pct: 97.5,
    total_delivered_qty: 195,
    outstanding_qty: 5,
    days_until_expiry: null,
    source_doc_ids: ['doc-001', 'doc-002'],
    created_at: '2024-01-15T08:00:00Z',
    updated_at: '2024-04-25T14:30:00Z',
  },
  {
    agreement_id: 'c-002',
    agreement_number: 'K-2024-015',
    agreement_type: 'purchase_agreement',
    direction: 'purchase',
    status: 'active',
    supplier: { party_id: 'org-raiffeisen', name: 'Raiffeisen Waren-Zentrale Rhein-Main eG', short_name: 'RWZ Rhein-Main' },
    buyer: { party_id: 'org-gut-sonnenberg', name: 'Betrieb Müller', short_name: 'Betrieb Müller' },
    product: { product_id: 'p-2', name: 'Winterweizen Reform Z', category: 'inputs.seed' },
    contracted_quantity: 25,
    quantity_unit: 'dt',
    unit_price: 68.0,
    currency: 'EUR',
    total_value: 1700.0,
    valid_from: '2024-09-01',
    valid_to: '2024-10-15',
    commission_pct: null,
    datasheet_required: false,
    datasheet_present: false,
    fulfillment_pct: 0,
    total_delivered_qty: 0,
    outstanding_qty: 25,
    days_until_expiry: 28,
    source_doc_ids: ['doc-010'],
    created_at: '2024-08-10T10:00:00Z',
    updated_at: '2024-08-10T10:00:00Z',
  },
  {
    agreement_id: 'c-003',
    agreement_number: 'K-2024-022',
    agreement_type: 'purchase_agreement',
    direction: 'purchase',
    status: 'partially_fulfilled',
    supplier: { party_id: 'org-baywa', name: 'BayWa AG Niederlassung Mainz', short_name: 'BayWa Mainz' },
    buyer: { party_id: 'org-gut-sonnenberg', name: 'Betrieb Müller', short_name: 'Betrieb Müller' },
    product: { product_id: 'p-3', name: 'NitroSulf 24+6 S', category: 'inputs.fertilizer' },
    contracted_quantity: 150,
    quantity_unit: 'dt',
    unit_price: 38.90,
    currency: 'EUR',
    total_value: 5835.0,
    valid_from: '2024-03-01',
    valid_to: '2024-06-30',
    commission_pct: null,
    datasheet_required: true,
    datasheet_present: false,
    fulfillment_pct: 65.3,
    total_delivered_qty: 98,
    outstanding_qty: 52,
    days_until_expiry: null,
    source_doc_ids: ['doc-020', 'doc-021'],
    created_at: '2024-02-20T09:00:00Z',
    updated_at: '2024-05-15T11:00:00Z',
  },
  {
    agreement_id: 'c-004',
    agreement_number: null,
    agreement_type: 'sales_agreement',
    direction: 'sale',
    status: 'partially_fulfilled',
    supplier: { party_id: 'org-gut-sonnenberg', name: 'Betrieb Müller', short_name: 'Betrieb Müller' },
    buyer: { party_id: 'org-frutania', name: 'FRUTANiA Obst & Gemüse Vertriebs GmbH', short_name: 'FRUTANiA' },
    product: { product_id: 'p-4', name: 'Erdbeeren 500g', category: 'outputs.fruit' },
    contracted_quantity: 5000,
    quantity_unit: 'Kolli',
    unit_price: 4.50,
    currency: 'EUR',
    total_value: 22500.0,
    valid_from: '2024-05-15',
    valid_to: '2024-08-31',
    commission_pct: 3.5,
    datasheet_required: false,
    datasheet_present: false,
    fulfillment_pct: 72.0,
    total_delivered_qty: 3600,
    outstanding_qty: 1400,
    days_until_expiry: null,
    source_doc_ids: ['doc-030', 'doc-031', 'doc-032'],
    created_at: '2024-05-10T07:00:00Z',
    updated_at: '2024-08-01T16:00:00Z',
  },
  {
    agreement_id: 'c-005',
    agreement_number: 'K-2024-008',
    agreement_type: 'sales_agreement',
    direction: 'sale',
    status: 'over_delivered',
    supplier: { party_id: 'org-gut-sonnenberg', name: 'Betrieb Müller', short_name: 'Betrieb Müller' },
    buyer: { party_id: 'org-getreidehandel-mueller', name: 'Getreidehandel Müller & Söhne', short_name: 'Müller & Söhne' },
    product: { product_id: 'p-5', name: 'Winterweizen A-Qualität', category: 'outputs.crops.grain' },
    contracted_quantity: 800,
    quantity_unit: 'dt',
    unit_price: 22.50,
    currency: 'EUR',
    total_value: 18000.0,
    valid_from: '2024-07-15',
    valid_to: '2024-09-30',
    commission_pct: null,
    datasheet_required: false,
    datasheet_present: false,
    fulfillment_pct: 108.5,
    total_delivered_qty: 868,
    outstanding_qty: 0,
    days_until_expiry: null,
    source_doc_ids: ['doc-040', 'doc-041', 'doc-042', 'doc-043'],
    created_at: '2024-06-01T08:00:00Z',
    updated_at: '2024-09-20T10:00:00Z',
  },
  {
    agreement_id: 'c-006',
    agreement_number: 'K-2024-030',
    agreement_type: 'purchase_agreement',
    direction: 'purchase',
    status: 'active',
    supplier: { party_id: 'org-raiffeisen', name: 'Raiffeisen Waren-Zentrale Rhein-Main eG', short_name: 'RWZ Rhein-Main' },
    buyer: { party_id: 'org-gut-sonnenberg', name: 'Betrieb Müller', short_name: 'Betrieb Müller' },
    product: { product_id: 'p-6', name: 'Harnstoff 46% N', category: 'inputs.fertilizer' },
    contracted_quantity: 100,
    quantity_unit: 'dt',
    unit_price: 42.00,
    currency: 'EUR',
    total_value: 4200.0,
    valid_from: '2025-02-01',
    valid_to: '2025-03-31',
    commission_pct: null,
    datasheet_required: true,
    datasheet_present: false,
    fulfillment_pct: 0,
    total_delivered_qty: 0,
    outstanding_qty: 100,
    days_until_expiry: 45,
    source_doc_ids: ['doc-050'],
    created_at: '2024-12-01T09:00:00Z',
    updated_at: '2024-12-01T09:00:00Z',
  },
];
